module.exports = __webpack_public_path__ + "media/images/photo/top/reason2-caf04f1d803057828a9e859ea5af6c3e.jpg";